import * as React from "react"
import {Table, TableBody, TableCell, TableContainer, TableHead, TableRow} from "@mui/material";
import {formatDate, formatNumber, formatPercentage} from "@ui-seeker/utils";

import {useUserApp} from "@hooks";
import {priceEvolutionWidgetFormatPrice} from "../../@utils";


export default function TableTitle({ data, isPercentage }) {
	const { userGroupByProductID } = useUserApp()
	return <TableContainer sx={{ maxHeight: 200, background: 'linear-gradient(110deg, rgba(210,210,210,1) 0%, rgba(230,230,230,1) 100%)' }}>
		<Table sx={{ width: 1 }}>
			<TableHead>
				<TableRow sx={{ position: 'sticky', top: 0, background: 'linear-gradient(110deg, rgba(210,210,210,1) 0%, rgba(230,230,230,1) 100%)' }}>
					<TableCell sx={{color: 'primary.darker', fontWeight: 'bold', textAlign: 'center', borderBottomColor: 'grey.500'}} >
						Date
					</TableCell>
					<TableCell sx={{color: 'primary.darker', fontWeight: 'bold', textAlign: 'center', borderBottomColor: 'grey.500'}} >
						Price
					</TableCell>
					{!userGroupByProductID && <TableCell sx={{color: 'primary.darker', fontWeight: 'bold', textAlign: 'center', borderBottomColor: 'grey.500'}} >
						Num Variants
					</TableCell>}
				</TableRow>
			</TableHead>

			<TableBody>
				{ data.map(({ date, kpi, currency, numVariants }, idx) => <TableRow key={idx}>
					<TableCell sx={{color: 'primary.darker', textAlign: 'center', borderBottomColor: 'grey.500'}}>
						{formatDate(date, { isString: true })}
					</TableCell>
					<TableCell sx={{color: 'primary.darker', textAlign: 'center', borderBottomColor: 'grey.500'}}>
						{ isPercentage ? formatPercentage(kpi) : priceEvolutionWidgetFormatPrice(kpi, currency) }
					</TableCell>
					{!userGroupByProductID && <TableCell sx={{color: 'primary.darker', textAlign: 'center', borderBottomColor: 'grey.500'}}>
						{numVariants}
					</TableCell>}
				</TableRow>)}
			</TableBody>
		</Table>
	</TableContainer>
}